import React, { Component } from "react";
import { Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import configData from "../config.json";
import "./Abha.css";
import ReCAPTCHA from 'react-google-recaptcha';
export default class ConsentCollectionAadhaar extends Component {
  constructor(props) {
    super(props);
    this.recaptchaRef = React.createRef();
    this.state = {
      textexpanded: false,
      aadharNumber: ["", "", ""], // for the 3 parts
      showAadhaar: false,
      termsCheck: false,
      // termsCheck2: false,
      termsCheck2: false,
      termsCheck3: false,
      termsCheck4: false,
      termsCheck5: false,
      termsCheck6: false,
      isSubmitting: false,
      captchaToken: null,
      authenticationtype: "aadharotp",
      
    };
  }
  handleCaptchaChange = (value) => {
    this.setState({
      captchaToken: value,
    });
  };
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
       case "warning":
      toast.warning(msg); // 'warn' is used instead of 'warning'
        break;
      default:
        toast.success(msg);
    }
  };
  toggleReadMore = () => {
    this.setState((prevState) => ({ textexpanded: !prevState.textexpanded }));
  };
  handleaadhaarchange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ aadharNumber: fieldValue });
  };

   validateVerhoeff(num) {
    const d = [
      [0,1,2,3,4,5,6,7,8,9],
      [1,2,3,4,0,6,7,8,9,5],
      [2,3,4,0,1,7,8,9,5,6],
      [3,4,0,1,2,8,9,5,6,7],
      [4,0,1,2,3,9,5,6,7,8],
      [5,9,8,7,6,0,4,3,2,1],
      [6,5,9,8,7,1,0,4,3,2],
      [7,6,5,9,8,2,1,0,4,3],
      [8,7,6,5,9,3,2,1,0,4],
      [9,8,7,6,5,4,3,2,1,0]
    ];
  
    const p = [
      [0,1,2,3,4,5,6,7,8,9],
      [1,5,7,6,2,8,3,0,9,4],
      [5,8,0,3,7,9,6,1,4,2],
      [8,9,1,6,0,4,3,5,2,7],
      [9,4,5,3,1,2,6,8,7,0],
      [4,2,8,6,5,7,9,3,0,1],
      [2,7,9,3,8,0,6,4,1,5],
      [7,0,4,6,9,1,3,2,5,8]
    ];
    let c = 0;
    const reversed = num.split("").reverse();
    for (let i = 0; i < reversed.length; i++) {
      c = d[c][p[i % 8][parseInt(reversed[i], 10)]];
    }
    return c === 0;
  }
  ValidAadhaarFormat(aadhaar) {
    return /^[2-9]{1}[0-9]{11}$/.test(aadhaar);
  }
  
  // Aadhaar validation
   isValidAadhaar(aadhaar, useVerhoeff = false) {
    const regex = /^[2-9]{1}[0-9]{11}$/; // 12 digits, starts with 2–9
    if (!regex.test(aadhaar)) return false;
    return useVerhoeff ? this.validateVerhoeff(aadhaar) : true;
    
  }
  HandleSubmit = (e) => {
    e.preventDefault();

    const {
      captchaToken,
      aadharNumber,
      termsCheck,
      // termsCheck2,
      termsCheck2,
      termsCheck3,
      termsCheck4,
      termsCheck5,
      termsCheck6,
      authenticationtype,
      consentName,
    } = this.state;
    const fullAadhaar = aadharNumber.join("");
    if (fullAadhaar.trim() === "") {
      this.showToast("Aadhaar number is required.", "error");
      return;
    }
    if(!this.ValidAadhaarFormat(fullAadhaar.trim()) ){
      this.showToast("Invalid Aadhaar Number.", "error");
      return;
    }
    const aadhaarRegex = /^\d{12}$/;
    if (!aadhaarRegex.test(fullAadhaar)) {
      this.showToast(
        "Aadhaar must be 12 digits long and contain only numbers.",
        "error"
      );
      return;
    } 
    if (!captchaToken) {
       this.showToast('Please verify that you are not a robot!',"error");
      return;
    }
    if(!consentName || consentName.trim()  ===""){
      this.showToast("Please Enter Aadhaar Person Name","error")
    }

    else if (!authenticationtype || authenticationtype.trim() === "") {
      this.showToast("Please Select Authentication Type", "error");
      return false;
    }
 
    const checkboxErrors = [
      {
        checked: termsCheck,
        message: "Please agree to the first consent box.",
      },
      // {
      //   checked: termsCheck2,
      //   message: "Please agree to the second consent box.",
      // },
      {
        checked: termsCheck2,
        message: "Please agree to the third consent box.",
      },
      {
        checked: termsCheck3,
        message: "Please agree to the fourth consent box.",
      },
      {
        checked: termsCheck4,
        message: "Please agree to the fifth consent box.",
      },
      {
        checked: termsCheck5,
        message: "Please agree to the sixth consent box.",
      },
      {
        checked: termsCheck6,
        message: "Please agree to the seventh consent box.",
      },
    ];

    for (let i = 0; i < checkboxErrors.length; i++) {
      if (!checkboxErrors[i].checked) {
        this.showToast(checkboxErrors[i].message, "warning");
        return;
      }
    }

    this.setState({ isSubmitting: true });
    var formData = new FormData();
    formData.append("aadharNumber", fullAadhaar);
    formData.append("captchaToken", captchaToken);
    formData.append("termsCheck", termsCheck ? true : false);
    formData.append("termsCheck2", termsCheck2 ?true : false);
    formData.append("termsCheck3", termsCheck3 ? true : false);
    formData.append("termsCheck4", termsCheck4 ? true : false);
    formData.append("termsCheck5", termsCheck5 ? true : false);
    formData.append("termsCheck6", termsCheck6 ? true : false);

    fetch(configData.api_url + "C_Abhadetails/add", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.showToast(data.message, data.status);
          window.location.href = "/aadhaarauthentication";
          sessionStorage.setItem("requestId", data.requestId);
          sessionStorage.setItem("message", data.details.message);
        } else {
           this.showToast(data.message || "Something went wrong. Please try again.","error");
        }
      
        this.setState({
          aadhaarNumber: "",
          isSubmitting: false,
        });
      
        if (this.recaptchaRef && this.recaptchaRef.current) {
          this.recaptchaRef.current.reset();
        }
      });
  };
  resetCaptcha = () => {
    this.setState({ captchaToken: "" });
    if (this.recaptchaRef && this.recaptchaRef.current) {
      this.recaptchaRef.current.reset();
    }
  };
  onKeyDown = (e) => {
    if (e.key === " ") {
      e.preventDefault();
      toast.error("Spaces are not allowed.");
    }
  };
  handleAadhaarPartChange = (index, value) => {
    const cleanValue = value.replace(/\D/g, "").slice(0, 4); // Only digits, max 4
    const updated = [...this.state.aadharNumber];
    updated[index] = cleanValue;
    this.setState({ aadharNumber: updated }, () => {
      if (
        cleanValue.length === 4 &&
        index < this.state.aadharNumber.length - 1
      ) {
        const nextInput = document.getElementById(`aadharNumber-${index + 1}`);
        if (nextInput) nextInput.focus();
      }
    });
  };
  handleKeyDownAadharNumber = (idx, e) => {
    if (e.key === "Backspace" && !this.state.aadharNumber[idx] && idx > 0) {
      document.getElementById(`aadharNumber-${idx - 1}`).focus();
    }
  };
  toggleAadhaarVisibility = () => {
    this.setState({ showAadhaar: !this.state.showAadhaar });
  };
  handleAuthChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ authenticationtype: fieldValue });
  };
  handleBack =()=>{
    window.location="./abharegister"
  }
  allCheckboxesChecked = () => {
    const {
      termsCheck,
      termsCheck2,
      termsCheck3,
      termsCheck4,
      termsCheck5,
      termsCheck6,
    } = this.state;
  
    // Return true only if all checkboxes are true
    return (
      termsCheck &&
      termsCheck2 &&
      termsCheck3 &&
      termsCheck4 &&
      termsCheck5 &&
      termsCheck6
    );
  };
  render() {
    return (
      <div>
         <div className="row justify-content-md-center text-center consentCollectionAadhaar">
          <h6 className="mt-3">Creating ABHA Using Aadhaar Number</h6>
            
         </div>

        <div className="row justify-content-md-center text-center consentCollectionAadhaar">
          <div className="col-md-6 mt-4">
            <div className="widget_BG widget_BG_grid mb-2">
              <Form>
                <Form.Group>
                  <Form.Label>
                    <b>Enter Your Aadhaar Number</b>
                  </Form.Label>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    {this.state.aadharNumber.map((val, idx) => (
                      <Form.Control
                        id={`aadharNumber-${idx}`}
                        className="formselect"
                        style={{
                          textAlign: "center",
                        }}
                        type={this.state.showAadhaar ? "text" : "password"}
                        maxLength={4}
                        value={val}
                        onChange={(e) =>
                          this.handleAadhaarPartChange(idx, e.target.value)
                        }
                        tabIdx={idx + 1}
                        onKeyDown={(e) =>
                          this.handleKeyDownAadharNumber(idx, e)
                        }
                      />
                    ))}
                    <Button
                      variant="outline-secondary"
                      style={{
                        width: "50px",
                        height: "36px",
                        fontSize: "16px",
                      }}
                      className={`rounded-0 bi ${
                        this.state.showAadhaar ? "bi-eye-slash" : "bi-eye"
                      }`}
                      onClick={() =>
                        this.setState({ showAadhaar: !this.state.showAadhaar })
                      }
                    />
                  </div>
                </Form.Group>
                <Form.Group
                  style={{
                    padddingTop: "10px",
                  }}
                >
                  <Form.Label className="authenticationType mt-3">
                    <b>Select Authentication Type</b>
                  </Form.Label>
                  <Form.Select
                    name="authenticationtype"
                    className="formselect"
                    aria-label="Default select example"
                    value={this.state.authenticationtype}
                    onChange={this.handleAuthChange}
                  >
                    <option value="aadharotp" default>
                      Aadhaar OTP
                    </option>
                  </Form.Select>
                </Form.Group>
                <p className="aadhaarOTP_paragraph">
                  Please ensure that mobile number is linked with Aadhaar as it
                  will be required for OTP authentication. If you do not have a
                  mobile number linked, visit the nearest ABDM participating
                  facility and seek assistance.
                </p>
              </Form>
            </div>
          </div>
        </div>
        <div className="row  widget_BG widget_BG_grid m-0 mt-2 herebyDeclareParagraph">
          <div className="col">
            <Form.Group>
              <p>I hereby declare that:</p>
              <Form.Check
                style={{ font: "inherit" }}
                type="checkbox"
                className="label"
                name="termsCheck"
                id="nonelectricalaccessories"
                label="I am voluntarily sharing my Aadhaar Number / 
                Virtual ID issued by the Unique Identification Authority 
                of India (“UIDAI”), and my demographic information for the purpose of 
                creating an Ayushman Bharat Health Account number (“ABHA number”) 
                and Ayushman Bharat Health Account address (“ABHA Address”).
                 I authorize NHA to use my Aadhaar number / Virtual ID
                  for performing Aadhaar based authentication with UIDAI 
                  as per the provisions of the Aadhaar (Targeted Delivery of Financial and other Subsidies, 
                  Benefits and Services) Act, 2016 for the aforesaid purpose.
                I understand that UIDAI will share my e-KYC details,
                 or response of “Yes” with NHA upon successful authentication."
                checked={this.state.termsCheck}
                onChange={(e) =>
                  this.setState({ termsCheck: e.target.checked })
                }
              />
              {/* <Form.Check
                style={{ font: "inherit" }}
                type="checkbox"
                className="label"
                name="termsCheck2"
                id="nonelectricalaccessories"
                label="I intend to create Ayushman Bharat Health Account Number (“ABHA number”) 
                and Ayushman Bharat Health Account address (“ABHA Address”) using document other 
                than Aadhaar. (Click here to proceed further)
"
                checked={this.state.termsCheck2}
                onChange={(e) =>
                  this.setState({ termsCheck2: e.target.checked })
                }
              /> */}
              <Form.Check
                style={{ font: "inherit" }}
                type="checkbox"
                className="label"
                name="termsCheck2"
                id="nonelectricalaccessories"
                label="I consent to usage of my ABHA address and ABHA number 
                for linking of my legacy (past)  health records and those which will be generated during this encounter.
"
                checked={this.state.termsCheck2}
                onChange={(e) =>
                  this.setState({ termsCheck2: e.target.checked })
                }
              />

              <Form.Check
                style={{ font: "inherit" }}
                type="checkbox"
                className="label"
                name="termsCheck3"
                id="nonelectricalaccessories"
                label="I authorize the sharing of all my health records with healthcare provider(s)
                 for the purpose of providing healthcare services to me during this encounter."
                checked={this.state.termsCheck3}
                onChange={(e) =>
                  this.setState({ termsCheck3: e.target.checked })
                }
              />
              <Form.Check
                style={{ font: "inherit" }}
                type="checkbox"
                className="label"
                name="termsCheck4"
                id="nonelectricalaccessories"
                label="I consent to the anonymization and subsequent use of my 
                 health records for public health purposes"
                checked={this.state.termsCheck4}
                onChange={(e) =>
                  this.setState({ termsCheck4: e.target.checked })
                }
              />
              <Form.Check
                style={{ font: "inherit",marginLeft:"50px" }}
                type="checkbox"
                className="label"
                name="termsCheck5"
                id="nonelectricalaccessoriess"
                label="I, (Apna Policy Insurance Brokers Private Limited ), confirm that I have duly informed 
                and explained the beneficiary of the contents of consent for aforementioned purposes.
"
                checked={this.state.termsCheck5}
                onChange={(e) =>
                  this.setState({ termsCheck5: e.target.checked })
                }
              />
              <Form.Check
                 style={{ font: "inherit",marginLeft:"50px" }}
                type="checkbox"
                className="label"
                name="termsCheck6"
                id="nonelectricalaccessories"
                label={`I, (${
                  this.state.consentName || " ______ "
                }) have been explained about the consent as stated above and hereby provide my consent for the aforementioned purposes`}
                checked={this.state.termsCheck6}
                onChange={(e) =>
                  this.setState({ termsCheck6: e.target.checked })
                }
              />
            </Form.Group>
          </div>
          <Form.Group controlId="consentName">
            <Form.Control
            className="mt-2"
              type="text"
              placeholder="Enter your name _________"
              value={this.state.consentName}
              onChange={(e) => this.setState({ consentName: e.target.value })}  
            />
          </Form.Group>

        
      <div className="d-flex">   <ReCAPTCHA 
          className="mt-4"
          ref={this.recaptchaRef} 
          sitekey= {configData.captchaKey}
          onChange={this.handleCaptchaChange}
        /> 
        <Button variant="secondary"  className="bi bi-arrow-clockwise re-chaptue" 
        onClick={() => this.recaptchaRef.current.reset()}/></div>
  

        </div>
       
        <div className="row  widget_BG widget_BG_grid m-0 mt-3">
        <div className="col text-start">
        
        <Button className="rounded-0 m-1 " variant="warning"
        onClick={this.handleBack}>
          Back
        </Button>
        </div>
          <div className="col text-end">
                
           
            <Button
              className="rounded-0 m-1"
              disabled={this.state.isSubmitting||!this.allCheckboxesChecked()}
              onClick={this.HandleSubmit}
            >
              {this.state.isSubmitting ? "Submitting...Please Wait" : "Next"}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
